class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bridge`;
    }
    /**
     * Allows the user to connect multiple call session participants over a conference call bridge.
     * The current active call session ID and party ID of the user within this session should be specified
     * in path; the bridged call session ID and party ID of the user within that session should be specified
     * in request body. Thus, the user connects participants of two sessions into the one conference call
     * using his/her own party IDs from both sessions."
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/bridge
     * Rate Limit Group: Light
     * App Permission: CallControl
     */
    async post(bridgeTargetRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), bridgeTargetRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
